import React from "react";

import ContentCore from "../../../../core/workingContent";

import "../../_index.css";

const TaskProcessingReceiverUI = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskProcessingReceiverUI;
